export enum ReviewType {
    Undefined = "undefined",
    HR = "hr",
    EHS = "ehs",
}
